import { useParams } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { SinglePageTitle } from 'components/Dashboards/Project/Components/VersionCompare/components/SinglePageTitle/singlePageTitle';
import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { TreeProgramTopHeader, VersionCompareSelectorWrapper } from 'components/common';
import { CriticalPathRemoved } from 'components/widgets/CriticalPathRemoved/CriticalPathRemoved';

export const CriticalPathRemovedSinglePage = () => {
    useFullStoryPageView({ pageName: executionConfig.versionCompare.title });
    const { id, versionToCompareId } = useParams<{ id: string; versionToCompareId: string }>();

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader isDisabled={true}>
                            <VersionCompareSelectorWrapper />
                        </TreeProgramTopHeader>
                    </VersionSection>
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader
                        pageTitle={executionConfig.criticalPathRemoved.title}
                        showBack={true}
                        showBackLink={AppRoutes.buildPath(
                            AppRoutes.DASHBOARD_PLANNING_PATH,
                            executionConfig.versionCompare.link,
                            id,
                            versionToCompareId,
                        )}
                    ></ProgramTopHeader>
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <PageWidgetWrapper>
                    <CriticalPathRemoved isSinglePage={true} />
                </PageWidgetWrapper>
            </MainContent>
            <MainCardRoutingModal queryKeys={['criticalPathRemovedTableData']} />
        </PageContainer>
    );
};
